import { createContext, useContext, useState, useEffect } from 'react';
import { isTokenExpired, limpiaLocalStorage } from '../utils/utils';
import { jwtDecode } from "jwt-decode";
const AuthContext = createContext();
//
// ################################################################################
//
const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const _token = localStorage.getItem("token");
    const _tokenExp = localStorage.getItem("token_exp");

    if (isTokenExpired(_token, _tokenExp)) {
      // si no hay token o el token expiró, se limpia el localStorage y se redirige al login

      limpiaLocalStorage();
      setLoading(false);
    } else {

      const _decodedToken = jwtDecode(_token);
      setAuth({
        roles: _decodedToken.roles,
        permisos: _decodedToken.permissions,
        token: _token,
        user: _decodedToken.user,
      });
      setLoading(false);
    }
  }, []);

  const hasPermission = (permiso) => {
    return auth?.permisos?.includes(permiso) || false;
  };

  if (loading) {
    return <div>Cargando...</div>;
  }

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated: !!auth,
        loading,
        auth,
        setAuth,
        hasPermission,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthProvider };
export default AuthContext;